import AuthPageLayout from '../components/AuthPageLayout';

export default function ErrorPage() {
  return (
    <AuthPageLayout
      title='Page not found'
      subtitle="This page doesn't exist. Start connecting your account from your partner's website."
    >
      <p className='text-sm text-center text-gray-600 dark:text-gray-400'>
        If you were authorizing a partner app, return to that app and try again from their connect
        flow.
      </p>
    </AuthPageLayout>
  );
}
